import { all, call, put, takeLatest } from "redux-saga/effects";
import {
  viewBusinessDetailsChanged,
  viewBusinessDetailsFailure,
  viewBusinessDetailsSuccess,
} from "./viewBusiness.action";
import viewBusinessDetailsTypes from "./viewBusiness.types";
import { encryptData } from "../../_common/enode-decode";
import { searchBusinessDetailsAPI } from "./viewBusiness.services";

export function* searchBusinessDetails({ payload }: any) {
  try {
    const key: any = "GetBusinessDetailsKey";
    const jsonData: any = {
      BusinessPhoneNumber: payload.SearchValue,
      CompanyID: payload.CompanyID,
      InstanceName: payload.InstanceName,
    };
    const fetchData = encryptData(jsonData, key);
    // @ts-ignore
    const responseData = yield call(searchBusinessDetailsAPI, fetchData);
    if (responseData.data.statusCode === "100") {
      yield put(viewBusinessDetailsFailure(responseData.data));
    } else {
      yield put(viewBusinessDetailsSuccess(responseData.data));
    }
  } catch (error) {
    yield put(viewBusinessDetailsFailure(error));
  }
}

export function* searchBusinessDetailsChanged() {
  yield put(viewBusinessDetailsChanged());
}

export function* startSearchBusinessDetails() {
  yield takeLatest(
    viewBusinessDetailsTypes.VIEW_BUSINESS_DETAILS_START,
    searchBusinessDetails,
  );
}

export function* startSearchBusinessDetailsChanged() {
  yield takeLatest(
    viewBusinessDetailsTypes.VIEW_BUSINESS_DETAILS_RESET,
    searchBusinessDetailsChanged,
  );
}

export function* searchBusinessDetailsSaga() {
  yield all([
    call(startSearchBusinessDetails),
    call(startSearchBusinessDetailsChanged),
  ]);
}
